import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { IconLogo, IconShopifyPartner } from '../assets/icons'
import { footerLinks, shopifyLinks, followLinks } from '../config'

const FooterWrapper = styled.footer`
  overflow: hidden;
  padding-top: 90px;
  background-color: var(--black-dark);
  @media screen and (max-width: 800px) {
    padding-top: 70px;
  }
`
const FooterContainer = styled.div`
  display: block;
  position: relative;
  z-index: 1;
  width: 86%;
  max-width: var(--max-width);
  margin: 0 auto;

  .icon-logo {
    position: absolute;
    z-index: -1;
    top: -170px;
    left: -160px;
    transform: rotate(-10deg);
    width: 620px;
    height: 620px;
    #bg {
      fill: var(--black-medium);
    }
  }
  h5 {
    margin-bottom: 50px;
    color: var(--text);
  }
  @media screen and (max-width: 800px) {
    width: calc(100% - 50px);
    margin: 0 25px;
    h5 {
      margin-bottom: 30px;
    }
  }
`
const FooterColumns = styled.div`
  display: flex;
  flex-direction: row;
  @media screen and (max-width: 1220px) {
    flex-wrap: wrap;
  }
  @media screen and (max-width: 800px) {
    flex-direction: column;
  }
`
const ColumnLeft = styled.div`
  flex: 0 0 40%;
  @media screen and (max-width: 1023px) {
    flex: 0 0 50%;
    margin-bottom: 70px;
  }
  @media screen and (max-width: 800px) {
    flex: 0 0 100%;
    margin-bottom: 55px;
  }
`
const ColumnShopify = styled.div`
  flex: 0 0 26%;
  a {
    display: block;
    margin-bottom: 12px;
    font-family: var(--font-condensed);
    font-size: var(--fz-lg);
    font-weight: 500;
    line-height: 24px;
    &:hover {
      color: var(--grey-medium);
    }
  }
  @media screen and (max-width: 1220px) {
    flex: 0 0 35%;
  }
  @media screen and (max-width: 1023px) {
    flex: 0 0 50%;
    margin-bottom: 70px;
  }
  @media screen and (max-width: 800px) {
    flex: 0 0 100%;
    margin-bottom: 40px;
  }
`
const ColumnLinks = styled.div`
  flex: 0 0 20%;
  padding-right: 15px;
  a {
    display: block;
    margin-bottom: 12px;
    font-family: var(--font-condensed);
    font-size: var(--fz-lg);
    font-weight: 500;
    line-height: 24px;
    &:hover {
      color: var(--grey-medium);
    }
  }
  @media screen and (max-width: 1220px) {
    flex: 0 0 25%;
  }
  @media screen and (max-width: 1023px) {
    flex: 0 0 50%;
    margin-bottom: 0px;
  }
  @media screen and (max-width: 800px) {
    flex: 0 0 100%;
    margin-bottom: 50px;
  }
`
const ColumnsFollow = styled.div`
  flex: 0 0 14%;
  .follow-list {
    display: flex;
    flex-direction: column;
  }
  .follow-list a {
    display: block;
    margin-right: 0px;
    margin-bottom: 12px;
    font-family: var(--font-condensed);
    font-size: var(--fz-lg);
    font-weight: 500;
    line-height: 24px;
    &:hover {
      color: var(--grey-medium);
    }
  }
  @media screen and (max-width: 1220px) {
    padding: 60px 0 0 40%;
    flex: 0 0 100%;
    .follow-list {
      flex-direction: row;
    }
    .follow-list a {
      margin-right: 20px;
    }
  }
  @media screen and (max-width: 1023px) {
    flex: 0 0 50%;
    padding: 0;
    margin-bottom: 0px;
    .follow-list {
      flex-direction: column;
    }
    .follow-list a {
      margin-right: 0;
    }
  }
  @media screen and (max-width: 800px) {
    flex: 0 0 100%;
    margin-bottom: 10px;
  }
`
const FooterPartner = styled.div`
  display: inline-block;
  position: relative;
  top: -75px;
  @media screen and (max-width: 1220px) {
    top: -225px;
  }
  @media screen and (max-width: 1023px) {
    margin-top: 60px;
    top: 0px;
  }
`
const FooterCopywright = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  padding: 50px 0;
  margin: 0;
  color: var(--text);
  font-size: var(--fz-sm);
  @media screen and (max-width: 1220px) {
    margin: -114px 0 0 0;
  }
  @media screen and (max-width: 1023px) {
    justify-content: start;
    margin: 0;
  }
`

const Footer = () => {
  const [date, setDate] = useState('')
  const getYear = () => setDate(new Date().getFullYear())

  useEffect(() => {
    getYear()
  }, [])

  return (
    <FooterWrapper>
      <FooterContainer>
        <IconLogo />
        <FooterColumns>
          <ColumnLeft>
            <h5>Robert Eberhard</h5>
            <h2>Shopify Design and Development.</h2>
          </ColumnLeft>
          <ColumnShopify>
            <h5>Services</h5>
            {shopifyLinks &&
              shopifyLinks.map(({ url, name }, i) => (
                <a href={url} key={i} aria-label={name}>
                  {name}
                </a>
              ))}
          </ColumnShopify>
          <ColumnLinks>
            <h5>Links</h5>
            {footerLinks &&
              footerLinks.map(({ url, name }, i) => (
                <Link to={url} key={i} aria-label={name}>
                  {name}
                </Link>
              ))}
          </ColumnLinks>
          <ColumnsFollow>
            <h5>Follow</h5>
            <div className="follow-list">
              {followLinks &&
                followLinks.map(({ url, name }, i) => (
                  <a href={url} key={i} aria-label={name} target="_blank">
                    {name}
                  </a>
                ))}
            </div>
          </ColumnsFollow>
        </FooterColumns>
        <FooterPartner>
          <IconShopifyPartner />
        </FooterPartner>
        <FooterCopywright>© 2007-{date} ROBERT EBERHARD</FooterCopywright>
      </FooterContainer>
    </FooterWrapper>
  )
}

export default Footer
